import React from "react";
import { Box, Flex, Heading, IconOnePass, Link, LinkButton, Text, } from "@catchoftheday/cg-components";
import { URL_ONEPASS_PUBLIC_MIGRATION } from "../../../consts";
import { ContentZone, SideImageZone, } from "../../layouts/MigrationModalLayout/MigrationModalLayout";
import { MigrationModalSideImage } from "../image-assets/MigrationModalSideImage";
import { OnePassModal } from "../OnePassModal";
import { BenefitItem } from "./BenefitItem";
import { BENEFITS } from "./benefits";
export const MigrationModal = ({ isOpen, ctaUrl, onClose, onProceed, onLearnMore, }) => {
    return (<OnePassModal sizeVariant="large" isOpen={isOpen} onRequestClose={onClose} contentProps={{
            height: "auto",
            px: 0,
            py: 0,
        }}>
      <Flex flexWrap="wrap" alignItems="center">
        <SideImageZone>
          <MigrationModalSideImage />
        </SideImageZone>
        <ContentZone>
          <Heading.h3 m={0} mb={4} fontWeight="bold">
            <IconOnePass color="onePass.primary" height="1em" width="auto" mr={1.5} title="OnePass" aria-label="OnePass" mt={-2}/>
            has moved to a new location
          </Heading.h3>
          <Box fontSize="sm" fontWeight="medium">
            <Text m={0} mb={4} fontWeight="inherit">
              Follow the steps to securely transfer your subscription to the new
              OnePass.
            </Text>
            <Text m={0} fontWeight="bold">
              You'll get access to:
            </Text>
            {BENEFITS.map(({ icon, description }, idx) => (<BenefitItem key={`migration-benefit-${idx}`} icon={icon}>
                {description}
              </BenefitItem>))}
          </Box>
          <LinkButton href={ctaUrl} variant="onePassPrimary" sizeVariant="sm" fontWeight="bold" mb={2} mt={4} onClick={onProceed}>
            Transfer to the new OnePass
          </LinkButton>
          <Box textAlign="center" mb={4}>
            <Link href={URL_ONEPASS_PUBLIC_MIGRATION} color="onePass.primary" hoverColor="onePass.primaryDarker" textDecoration="underline" fontSize="xs" fontWeight="bold" onClick={onLearnMore}>
              Find out more
            </Link>
          </Box>
          <Text fontSize="xs" textAlign="center" fontWeight="medium" color="textTertiary" m={0}>
            *Excludes bulky, special order and marketplace items
          </Text>
        </ContentZone>
      </Flex>
    </OnePassModal>);
};
